<template>
    <v-row>
        <v-col
            cols="12"
            md="6"
        >
            <v-card>
                <v-form
                    ref="customerForm"
                    v-model="isValid"
                >
                    <v-card-text>
                        <v-container
                            class="pb-0"
                            fluid
                        >
                            <v-row class="pb-0">
                                <v-divider></v-divider>
                                <v-col
                                    cols="12"
                                    justify="start"
                                >
                                    <v-btn
                                        @click="loadIdentityFindAddForm"
                                        class="text-none"
                                        color="light-blue darken-1"
                                        dark
                                        v-if="!customer.identityId"
                                    >
                                        <v-icon
                                            dark
                                            left
                                        >mdi-account</v-icon>Specify Identity
                                    </v-btn>
                                    <v-btn
                                        @click="customer.identityId = null"
                                        class="text-none"
                                        color="light-blue darken-1"
                                        text
                                        v-if="
                                            !!customer.identityId &&
                                            !customer.id
                                        "
                                    >
                                        <v-icon
                                            dark
                                            left
                                        >mdi-close</v-icon>Clear Identity
                                    </v-btn>
                                    <v-card
                                        @click="
                                            loadIdentityForm(customer.identity)
                                        "
                                        v-if="customer.identityId"
                                    >
                                        <v-card-text>
                                            {{ customer.identity.name }}
                                            {{ customer.identity.surname }}
                                            <br />
                                            <!--<span v-if="identityTypes">
                                                {{
                                                identityTypes.find(
                                                (x) =>
                                                x.key ==
                                                customer.identity
                                                .identityTypeId
                                                ).value
                                                }}
                                            </span>-->
                                            <br />
                                            {{
                                            customer.identity
                                            .identificationNumber
                                            }}
                                        </v-card-text>
                                    </v-card>
                                    <br />
                                    <div
                                        style="color: red"
                                        v-show="customer.identityId === 0"
                                    >Customer identity is required</div>
                                </v-col>

                                <v-col cols="12">
                                    <v-select
                                        :disabled="isLoading"
                                        :items="subscriptions"
                                        :rules="[requiredRule]"
                                        item-text="value"
                                        item-value="key"
                                        label="Subscription"
                                        v-model="customer.subscriptionId"
                                    ></v-select>
                                </v-col>

                                <v-col cols="12">
                                    <v-switch
                                        class="mb-0"
                                        label="Part of Company"
                                        v-model="isPartOfCompany"
                                    ></v-switch>
                                </v-col>

                                <v-divider></v-divider>
                                <v-col cols="12">
                                    <v-select
                                        :disabled="isLoading"
                                        :items="brokers"
                                        :rules="[]"
                                        clearable
                                        item-text="value"
                                        item-value="key"
                                        label="Broker"
                                        v-model="customer.brokerId"
                                    ></v-select>
                                </v-col>

                                <v-expand-transition>
                                    <v-col
                                        cols="12"
                                        v-show="isPartOfCompany == true"
                                    >
                                        <v-select
                                            :disabled="isLoading"
                                            :items="companies"
                                            :rules="[]"
                                            clearable
                                            item-text="value"
                                            item-value="key"
                                            label="Company"
                                            v-model="customer.customerCompanyId"
                                        ></v-select>
                                    </v-col>
                                </v-expand-transition>

                                <v-col cols="12" v-show="isPartOfCompany == true">
                                    <v-select
                                        :disabled="isLoading"
                                        :items="customerStatusesCompany"
                                        :rules="[]"
                                            item-text="value"
                                            item-value="key"
                                        label="Status"
                                        v-model="customer.customerStatusCompany"
                                    ></v-select>
                                </v-col>

                                <v-col cols="12" v-show="isPartOfCompany == false">
                                    <v-select
                                        :disabled="isLoading"
                                        :items="customerStatusesIndividual"
                                        :rules="[]"
                                            item-text="value"
                                            item-value="key"
                                        label="Status"
                                        v-model="customer.customerStatusIndividual"
                                    ></v-select>
                                </v-col>

                                <v-col cols="12">
                                    <v-text-field
                                        :disabled="isLoading"
                                        :rules="[lengthRule(100)]"
                                        label="Card Number"
                                        v-model="customer.cardNumber"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12">
                                    <v-select
                                        :disabled="isLoading"
                                        :items="accisureReps"
                                        clearable
                                        item-text="value"
                                        item-value="key"
                                        label="Signed By"
                                        v-model="customer.signedUpByUserId"
                                    ></v-select>
                                </v-col>

                                <!--<v-divider></v-divider>
                                <v-col cols="12">
                                    <v-file-input
                                        :disabled="isLoading"
                                        accept="image/png, image/jpeg, image/bmp, application/pdf"
                                        label="Application Document"
                                        placeholder="Set Application Document"
                                        v-model="applicationForm"
                                    >
                                        <template slot="append-outer">
                                            <v-btn
                                                @click.stop="
                                                    getFile(
                                                        customer.applicationFormFileId,
                                                        'customer_' +
                                                            customer.id +
                                                            '_application-form_' +
                                                            customer.applicationFormFileId
                                                    )
                                                "
                                                elevation="1"
                                                fab
                                                small
                                                v-show="
                                                    customer.applicationFormFileId >
                                                    0
                                                "
                                            >
                                                <h3>
                                                    <v-icon color="light-blue">mdi-download</v-icon>
                                                </h3>
                                            </v-btn>
                                        </template>
                                    </v-file-input>
                                </v-col>-->

                                <!--<v-col cols="12">
                                    <v-file-input
                                        :disabled="isLoading"
                                        accept="image/png, image/jpeg, image/bmp, application/pdf"
                                        label="Consent Form"
                                        placeholder="Set Consent Form"
                                        v-model="consentForm"
                                    >
                                        <template slot="append-outer">
                                            <v-btn
                                                @click.stop="
                                                    getFile(
                                                        customer.consentFormFileId,
                                                        'customer_' +
                                                            customer.id +
                                                            '_application-form_' +
                                                            customer.consentFormFileId
                                                    )
                                                "
                                                elevation="1"
                                                fab
                                                small
                                                v-show="
                                                    customer.consentFormFileId >
                                                    0
                                                "
                                            >
                                                <h3>
                                                    <v-icon color="light-blue">mdi-download</v-icon>
                                                </h3>
                                            </v-btn>
                                        </template>
                                    </v-file-input>
                                </v-col>-->

                                <v-divider></v-divider>
                                                                <v-col cols="12">
                                    <v-text-field
                                        :disabled="isLoading"
                                        :rules="[lengthRule(100)]"
                                        label="Emergency Contact Number"
                                        v-model="customer.emergencyContactNumber"
                                    ></v-text-field>
                                </v-col>
                                <v-divider></v-divider>
                                <v-expand-transition>
                                    <v-col cols="12" v-show="isPartOfCompany == false">
                                <v-col cols="12">
                                    <v-text-field
                                        :disabled="isLoading"
                                        :rules="[lengthRule(100)]"
                                        label="Person Responsible Name"
                                        v-model="customer.personResponsibleName"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        :disabled="isLoading"
                                        :rules="[lengthRule(100)]"
                                        label="Person Responsible Contact Info"
                                        v-model="customer.personResponsibleContactInfo"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12">
                                    <v-text-field
                                        :disabled="isLoading"
                                        :rules="[lengthRule(30)]"
                                        label="Bank Name"
                                        v-model="customer.bankName"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        :disabled="isLoading"
                                        :rules="[lengthRule(30)]"
                                        label="Branch Code"
                                        v-model="customer.bankBranchCode"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12">
                                    <v-text-field
                                        :disabled="isLoading"
                                        :rules="[lengthRule(30)]"
                                        label="Account Number"
                                        v-model="customer.bankAccountNumber"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-select
                                        :disabled="isLoading"
                                        :items="bankAccountTypes"
                                        :rules="[]"
                                        clearable
                                        item-text="value"
                                        item-value="key"
                                        label="Account Type"
                                        v-model="customer.bankAccountType"
                                    ></v-select>
                                </v-col>
                                </v-col>
                                </v-expand-transition>

                                <v-col cols="12">
                                    <v-menu
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        min-width="290px"
                                        offset-y
                                        transition="scale-transition"
                                        v-model="commencementDateMenu"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                :rules="[requiredRule]"
                                                clearable
                                                label="Commencement Date"
                                                prepend-icon="mdi-calendar-month"
                                                readonly
                                                v-bind="attrs"
                                                v-model="customer.commencementDate"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            @input="commencementDateMenu = false"
                                            color="secondary"
                                            v-model="customer.commencementDate"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12">
                                    <v-select
                                        :disabled="isLoading"
                                        :items="debitOrderDates"
                                        :rules="[requiredRule]"
                                        item-text="value"
                                        item-value="key"
                                        label="Debit Order Date"
                                        v-model="customer.debitOrderDate"
                                    ></v-select>
                                </v-col>
                            </v-row>


                            <v-row
                                align="end"
                                class="pt-0"
                                justify="space-between"
                                no-gutters
                                v-show="customer.id > 0"
                            >
                                <v-col cols="12" >
                                    <v-select
                                        :disabled="isLoading"
                                        :items="consentSmsStatuses"
                                        readonly
                                        item-text="value"
                                        item-value="key"
                                        label="Consent Sms Status"
                                        v-model="customer.consentSms"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12">
                                <v-btn
                                    :disabled="(isLoading && !isSendingConsentSms) || customer.consentSms > 0"
                                    :loading="isSendingConsentSms"
                                    @click="sendConsentSms"
                                    class="text-none"
                                    color="secondary darken-1"
                                    >Send Consent Sms</v-btn>
                                </v-col>
                            </v-row>
                            <br/>
                            <!--<v-row
                                align="end"
                                class="pt-0"
                                justify="space-between"
                                no-gutters
                            >
                                <v-btn
                                    :disabled="isLoading && !isSendingWelcome"
                                    :loading="isSendingWelcome"
                                    @click="sendWelcomeEmail"
                                    class="text-none"
                                    color="secondary darken-1"
                                    v-show="customer.id > 0"
                                >Send Welcome Email</v-btn>
                                {{ customer.welcomeEmailSentAt }}
                            </v-row>
                            <br />-->
                            <v-row
                                align="end"
                                class="pt-0"
                                justify="space-between"
                                no-gutters
                                v-show="customer.id > 0"
                            >
                                <v-col cols="12" >
                                    <v-select
                                        :disabled="isLoading"
                                        :items="consentSmsStatuses"
                                        readonly
                                        item-text="value"
                                        item-value="key"
                                        label="Welcome Sms Status"
                                        v-model="customer.welcomeSms"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" >
                                    <v-btn
                                        :disabled="(isLoading && !isSendingWelcome) || customer.welcomeSms > 0"
                                        :loading="isSendingWelcome"
                                        @click="sendWelcomeSms"
                                        class="text-none"
                                        color="secondary darken-1"

                                    >Send Welcome Sms</v-btn>
                                    <!--{{ customer.welcomeSmsSentAt }}-->
                                 </v-col>
                            </v-row>
                            <br />
                            <v-row><v-col cols="12" >
                                <v-btn
                                    :disabled="isLoading && !isSendingWelcome"
                                    @click="showSmsForm()"
                                    class="text-none"
                                    color="secondary darken-1"
                                    v-show="customer.id > 0"
                                >Send sms</v-btn>
                                </v-col>
                                <br />
                                <v-col cols="12" >
                                <v-btn
                                    :disabled="isLoading && !isSendingCardSms"
                                    @click="sendCustomerCardSms"
                                    class="text-none"
                                    color="secondary darken-1"
                                    v-show="customer.id > 0"
                                >Send card sms</v-btn>
                                </v-col>
                            </v-row>

                            <br />
                            <v-row
                                align="end"
                                class="pt-0"
                                justify="space-between"
                                no-gutters
                            >
                                <v-btn
                                    :disabled="isLoading && !isDeleting"
                                    :loading="isDeleting"
                                    @click="deleteEntity"
                                    class="text-none"
                                    color="warning darken-1"
                                    text
                                    v-show="customer.id > 0"
                                >Delete</v-btn>
                                <v-btn
                                    :disabled="isLoading"
                                    @click="closeForm"
                                    class="text-none"
                                    color="secondary darken-1"
                                    text
                                >Close</v-btn>
                                <v-btn
                                    :disabled="isLoading && !isSaving"
                                    :loading="isSaving"
                                    @click="saveEntity"
                                    class="text-none"
                                    color="secondary darken-1"
                                    text
                                >
                                    {{
                                    customer.id > 0 ? "Update" : "Add"
                                    }}
                                </v-btn>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-form>
                <v-snackbar
                    :color="notifyColor"
                    :timeout="15000"
                    top
                    v-model="notifyShow"
                >
                    {{ notifyMessage }}
                    <template v-slot:action="{ attrs }">
                        <v-btn
                            @click="notifyShow = false"
                            class="text-none"
                            icon
                            v-bind="attrs"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </template>
                </v-snackbar>
            </v-card>
        </v-col>
        <v-col
            cols="12"
            md="6"
            no-gutters
        >
            <v-col
                cols="12"
                v-show="customer.id > 0"
            >
                <h3>
                    Notes
                    <v-btn
                        :disabled="isLoading"
                        @click="newNoteShow = true"
                        class="text-none ml-2"
                        color="secondary darken-1"
                        fab
                        x-small
                    >
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </h3>
                <v-card
                    :key="note.id"
                    class="mt-5"
                    no-gutters
                    v-for="note in customer.notes"
                >
                    <v-card-subtitle>
                        {{ note.author }}
                        <br />
                        {{ note.createdAt }}
                    </v-card-subtitle>
                    <v-card-text style="white-space: pre-wrap;">{{ note.text }}</v-card-text>
                </v-card>
            </v-col>
            <v-col
                cols="12"
                v-show="customer.id > 0"
            >
                <h3>
                    Dependants
                    <v-btn
                        :disabled="isLoading"
                        @click="newDependant"
                        class="text-none ml-2"
                        color="secondary darken-1"
                        fab
                        x-small
                    >
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </h3>
                <v-col
                    :key="dependant.id"
                    cols="12"
                    justify="start"
                    no-gutters
                    v-for="dependant in customer.dependants"
                >
                    <v-card @click="loadDependantForm(dependant)">
                        <v-card-text>
                            <v-row>
                                <v-col
                                    cols="6"
                                    lg="3"
                                    md="4"
                                    xl="2"
                                >
                                    {{ dependant.dependantIdentity.name }}
                                    {{ dependant.dependantIdentity.surname }}
                                    <br />
                                    <!--<span v-if="identityTypes">
                                        {{
                                        identityTypes.find(
                                        (x) =>
                                        x.key ==
                                        dependant.dependantIdentity.identityTypeId
                                        ).value
                                        }}
                                    </span>-->
                                    <br />
                                    {{ dependant.dependantIdentity.identificationNumber }}
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-col>
            <v-col  cols="12"
                  md="12"
                  no-gutters>
              <!-- @@Downloads-->
              <customer-downloads-card :customer-id="customer.id" :identification-number="customer.identity.identificationNumber"/>
            </v-col>
        </v-col>
        <v-dialog
            persistent
            v-model="identityFindAddFormVisible"
            width="500px"
        >
            <IdentityFindAddForm
                :allowDeceased="true"
                :key="identityFindAddFormKey"
                @close="closeIdentityFindAddForm"
                @located="locatedIdentity"
            />
        </v-dialog>
        <v-dialog
            persistent
            v-model="identityFormVisible"
            width="500px"
        >
            <IdentityForm
                :hide-delete="true"
                :identity-in="identityFormIdentity"
                :identity-types="identityTypes"
                :key="identityFormKey"
                @close="closeIdentityForm"
                @saved="savedIdentity"
            />
        </v-dialog>
        <v-dialog
            persistent
            v-model="dependantFormVisible"
            width="500px"
        >
            <DependantForm
                :customer-dependant-in="dependantFormDependant"
                :customer-id="customer.id"
                :key="dependantFormKey"
                @close="closeDependantForm"
                @deleted="deletedDependant"
                @saved="savedDependant"
                @savedIdentity="savedIdentity"
            />
        </v-dialog>

        <v-dialog
            persistent
            v-model="smsFormVisible"
            width="500px"
        >
            <AccisureSmsCustomerForm
                :customer-id="customer.id"
                :key="customer.id"
                @close="closeSmsForm"
            />
        </v-dialog>

        <v-dialog
            persistent
            v-model="newNoteShow"
            width="500px"
        >
            <v-card>
                <v-card-title></v-card-title>
                <v-card-text>
                    <v-textarea
                        :rules="[lengthRule(512)]"
                        counter
                        label="Note"
                        v-model="newNoteText"
                    ></v-textarea>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        @click="
                () => {
                  newNoteShow = false;
                  newNoteText = '';
                }
              "
                        class="text-none"
                        color="secondary darken-1"
                        text
                    >Close</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        :disabled="isLoading || newNoteAdding || newNoteText.length == 0"
                        :loading="newNoteAdding"
                        @click="newNoteAdd"
                        class="text-none"
                        color="secondary darken-1"
                        text
                    >Add</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import Customer from "../../models/Customer.model";
import Identity from "../../models/Identity.model";
import IdentityForm from "./IdentityForm";
import IdentityFindAddForm from "../forms/IdentityFindAddForm";
import DependantForm from "./CustomerDependantForm";
import CustomerDependant from "../../models/CustomerDependant.model";
import dateToString from "../../helpers/dateToString";
import AccisureSmsCustomerForm from "../forms/AccisureSmsCustomerForm";
import CustomerDownloadsCard from "@/components/widgets/CustomerDownloadsCard.vue";
export default {
    props: {
        customerIn: Object,
        companies: Array,
        subscriptions: Array,
        statuses: Array
    },
    components: {
        IdentityForm,
        IdentityFindAddForm,
        DependantForm,
        AccisureSmsCustomerForm,
        CustomerDownloadsCard
        //
    },
    mounted: function() {
        this.isPartOfCompany = this.customer.customerCompanyId > 0;
    },
    created: async function() {
        this.identityTypes = await this.$store.dispatch("identities/getTypes");
        this.bankAccountTypes = await this.$store.dispatch(
            "customers/getbankaccounttypes"
        );
        this.accisureReps = await this.$store.dispatch("users/getAccisureReps");

        this.debitOrderDates = await this.$store.dispatch(
            "customers/getDebitOrderDates"
        );

        this.consentSmsStatuses = await this.$store.dispatch(
            "customers/getConsentSmsStatuses"
        );

        this.customerStatusesCompany = await this.$store.dispatch(
            "customers/getCustomerStatusesCompany"
        );

        this.customerStatusesIndividual = await this.$store.dispatch(
            "customers/getCustomerStatusesIndividual"
        );

        this.customer.commencementDate = dateToString(
            this.customer.commencementDate
                ? new Date(this.customer.commencementDate)
                : null
        );

        this.brokers = await this.$store.dispatch("brokers/getlist");

    },
    data() {
        return {
            customer: new Customer().set(this.customerIn),
            isPartOfCompany: false,
            identityTypes: null,
            accisureReps: null,
            debitOrderDates: null,
            bankAccountTypes: null,
            consentSmsStatuses: null,
            applicationForm: [],
            consentForm: [],
            brokers: [],
            isValid: null,
            isLoading: null,
            isSaving: null,
            isDeleting: null,
            isSendingWelcome: null,
            notifyShow: null,
            notifyMessage: null,
            notifyColor: null,
            requiredRule: v => !!v || "required",
            lengthRule: limit => v =>
                !v || v.length <= limit || "exceeds " + limit + " characters",
            emailRule: v => /.+@.+$/.test(v) || "invalid email",

            identityFindAddFormVisible: false,
            identityFindAddFormKey: 0,

            identityFormVisible: false,
            identityFormKey: 0,
            identityFormIdentity: new Identity(),

            dependantFormKey: null,
            dependantFormDependant: null,
            dependantFormVisible: false,

            commencementDateMenu: false,

            newNoteShow: null,
            newNoteAdding: false,
            newNoteText: "",

            smsFormVisible: false,
            isSendingConsentSms: false,

            isSendingCardSms: false,

            customerStatusesCompany: [],
            customerStatusesIndividual: [],
        };
    },

    methods: {
        closeSmsForm() {
            this.smsFormVisible = false;
        },
        showSmsForm() {
            this.smsFormVisible = true;
        },
        getFile(fileId, namePrefix) {
            this.$store.dispatch("files/get", {
                fileId: fileId,
                namePrefix: namePrefix
            });
        },
        //emitters      ------------------------------------------------------------
        emitSavedEntity(savedCustomer) {
            this.$emit("saved", savedCustomer);
        },
        emitDeletedEntity(deletedCustomer) {
            this.$emit("deleted", deletedCustomer);
        },
        emitCloseForm() {
            this.$emit("close");
        },
        //general       ------------------------------------------------------------
        notify(message, color) {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
        },
        closeForm() {
            this.notifyShow = false;
            this.emitCloseForm();
        },
        sendWelcomeEmail() {
            this.isSendingWelcome = true;
            this.isLoading = true;

            this.$store
                .dispatch("customers/sendwelcomeemail", this.customer.id)
                .then(
                    () => {
                        this.notify("Customer welcome sent.", "success");
                    },
                    error => this.notify(error.response.data, "error")
                )
                .finally(this.saveEntityDone);
        },
        sendCustomerCardSms() {
            this.isSendingCardSms = true;
            this.isLoading = true;

            this.$store
                .dispatch("customers/sendcustomercardsms", {customerId: this.customer.id})
                .then(
                    () => {
                        this.notify("Customer card sms sent.", "success");
                    },
                    error => this.notify(error.response.data, "error")
                )
                .finally(this.saveEntityDone);
        },
        sendConsentSms() {
            this.isSendingConsentSms = true;
            this.isLoading = true;

            this.$store
                .dispatch("customers/sendconsentsms", {customerId: this.customer.id})
                .then(
                    () => {
                        this.notify("Customer consent request sent.", "success");
                        this.customer.consentSms = 1;
                    },
                    error => this.notify(error.response.data, "error")
                )
                .finally(this.saveEntityDone);
        },
        sendWelcomeSms() {
            this.isSendingWelcome = true;
            this.isLoading = true;

            this.$store
                .dispatch("customers/sendwelcomesms",  {customerId: this.customer.id})
                .then(
                    () => {
                        this.notify("Customer welcome sent.", "success");
                        this.customer.welcomeSms = 1;
                    },
                    error => this.notify(error.response.data, "error")
                )
                .finally(this.saveEntityDone);
        },
        validateForm() {
            this.isValid = this.$refs.customerForm.validate();

            if (!(this.customer.identityId > 0)) this.customer.identityId = 0;

            if (this.isValid) return this.customer.identityId > 0;
            else return false;
        },
        //save      ------------------------------------------------------------
        saveEntity() {
            if (this.validateForm()) {
                this.isLoading = true;
                this.isSaving = true;

                if (this.isPartOfCompany == false)
                    this.customer.customerCompanyId = null;

                var formdata = new FormData();
                formdata.append("ApplicationForm", this.applicationForm);
                formdata.append("ConsentForm", this.consentForm);
                formdata.append("Model", JSON.stringify(this.customer));

                const parameters = {
                    id: this.customer.id,
                    formData: formdata
                };

                this.$store
                    .dispatch(
                        "customers/" +
                            (this.customer.id == 0 ? "create" : "update"),
                        this.customer.id == 0 ? parameters.formData : parameters
                    )
                    .then(
                        customerWithInfo => {
                            this.notify(
                                "Customer successfully saved.",
                                "success"
                            );
                            if (this.customer.id == 0) {
                                this.customer.id = customerWithInfo.entity.id;
                            }
                            this.customer.applicationFormFileId =
                                customerWithInfo.entity.applicationFormFileId;
                            this.applicationForm = null;

                            this.customer.consentFormFileId =
                                customerWithInfo.entity.consentFormFileId;
                            this.consentForm = null;

                            this.emitSavedEntity(customerWithInfo);
                        },
                        error => this.notify(error.response.data, "error")
                    )
                    .finally(this.saveEntityDone);
            }
        },
        saveEntityDone() {
            this.isLoading = false;
            this.isSaving = false;
            this.isSendingWelcome = false;
            this.isSendingConsentSms = false;
            this.isSendingCardSms = false;
        },
        //delete        ------------------------------------------------------------
        deleteEntity() {
            var isConfirmed = confirm(
                "Are you sure you want to delete this customer?"
            );
            if (isConfirmed) {
                this.isLoading = true;
                this.isDeleting = true;
                this.$store
                    .dispatch("customers/delete", this.customer.id)
                    .then(
                        () => {
                            this.notify(
                                "Customer successfully deleted.",
                                "success"
                            );
                            this.emitDeletedEntity(this.customer);
                            this.closeForm();
                        },
                        error => this.notify(error.response.data, "error")
                    )
                    .finally(this.deleteEntityDone);
            }
        },
        deleteEntityDone() {
            this.isLoading = false;
            this.isDeleting = false;
        },
        //primary IdentityFindAddForm
        loadIdentityFindAddForm() {
            this.identityFindAddFormKey += 1;
            this.identityFindAddFormVisible = true;
        },
        closeIdentityFindAddForm() {
            this.identityFindAddFormVisible = false;
        },
        locatedIdentity(identity) {
            this.customer.identityId = identity.id;
            this.customer.identity = identity;
        },

        //primary IdentityForm
        loadIdentityForm(identity) {
            this.identityFormIdentity = new Identity().set(identity);
            this.identityFormKey = identity.id;
            this.identityFormVisible = true;
        },
        closeIdentityForm() {
            this.identityFormVisible = false;
            this.identityFormIdentity = new Identity();
            this.identityFormKey = null;
        },
        savedIdentity(identityIn) {
            this.customer.dependants.forEach(dependant => {
                if (dependant.id == identityIn.entity.id)
                    dependant = identityIn.entity;
            });

            if (this.customer.identity.id == identityIn.entity.id)
                this.customer.identity = identityIn.entity;

            this.emitSavedEntity(this.customer);
        },

        //dependant form
        newDependant() {
            var dependant = new CustomerDependant();
            dependant.id = 0;
            dependant.customerId = this.customer.id;
            this.loadDependantForm(dependant);
        },
        loadDependantForm(dependant) {
            this.dependantFormDependant = dependant;
            this.dependantFormKey = dependant.id;
            this.dependantFormVisible = true;
        },
        closeDependantForm() {
            this.dependantFormKey = null;
            this.dependantFormVisible = false;
        },
        savedDependant(dependant) {
            var updateIndex = this.customer.dependants.findIndex(
                x => x.id == dependant.entity.id
            );
            if (updateIndex > -1)
                this.$set(
                    this.customer.dependants,
                    updateIndex,
                    dependant.entity
                );
            else this.customer.dependants.push(dependant.entity);
            this.emitSavedEntity(this.customer);
        },
        deletedDependant(dependant) {
            var deletedIndex = this.customer.dependants.findIndex(
                x => x.id == dependant.id
            );
            if (deletedIndex > -1)
                this.$delete(this.customer.dependants, deletedIndex);

            //this.emitDeletedDependant(dependant);
        },
        //note
        newNoteAdd() {
            this.isLoading = true;
            this.newNoteAdding = true;
            this.$store
                .dispatch("customers/addNote", {
                    customerId: this.customer.id,
                    text: this.newNoteText
                })
                .then(
                    response => {
                        this.customer.notes.push({
                            id: response.id,
                            author: response.author,
                            text: response.text,
                            createdAt: response.createdAt
                        });
                        this.emitSavedEntity(null);
                        this.newNoteAddingDone();
                        this.newNoteShow = false;
                        this.newNoteText = "";
                    },
                    error => this.notify(error.response.data, "error")
                )
                .finally(this.newNoteAddingDone);
        },
        newNoteAddingDone() {
            this.newNoteAdding = false;
            this.isLoading = false;
        }
    }
};
</script>

<style lang="stylus" scoped></style>
